export enum FilterType {
  EQUAL = 'EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  LIKE = 'LIKE',
  BETWEEN = 'BETWEEN',
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN',
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL',
  NULL = 'NULL',
  NOT_NULL = 'NOT_NULL',
  IN = 'IN',
  NOT_IN = 'NOT_IN'
}
